<template>
  <div v-if="masterCampaign">
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>Sms Template</h2>
        </div>
      </div>

      <div class="col-8 mb-5">
        <h6>Sms variables</h6>
        <p class="mb-0">
          The following variables can be defined in a Campaign sms template,<br />
          which will be replaced with concrete user data when generating the sms:<br />
        </p>

        <div class="mt-3">
          <vs-row class="ml-5 my-1" v-for="item in handlebars" :key="item.handlebar">
            <vs-chip class="cursor-pointer" @click.native="addHandlebar(item.handlebar)">
              <b>{{ item.handlebar }}</b>
            </vs-chip>
            <span class="ml-2 mt-1">{{ item.description }}</span>
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>SMS</span>
        </div>
        <div class="vx-col sm:w-4/5">
          <vs-textarea label="" v-model="masterCampaign.smsContent" />
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row vs-justify="flex-end" class="flex flex-wrap items-center" style="margin-top: 32px">
        <vs-button v-if="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')" id="save-button" @click="$emit('onSave')" class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: ["masterCampaign", "isEditable"],
  computed: {
    handlebars() {
      return this.$store.getters["handlebars/getFor"]("guest", "venue", "sendDate").map(e => {
        return {
          handlebar: `{{${e.handlebar}}}`,
          description: e.description,
        };
      });
    },
  },
  methods: {
    addHandlebar(handlebar) {
      this.masterCampaign.smsContent += handlebar;
    },
  },
};
</script>

<style lang="scss">
</style>